import { ApolloCache, DefaultContext, MutationUpdaterFunction } from '@apollo/client';
import {
  ContractCreateInput,
  ContractCreateMutation,
  ContractsListDocument,
  ContractsListQuery,
  ContractsListQueryVariables,
  DocumentsDocument,
  DocumentsQuery,
  DocumentsQueryVariables,
  Exact,
} from 'generated/graphql';

type DocumentEdge = DocumentsQuery['documents']['edges'][number];

export const updateCacheOnCreate: (
  clientId: string
) => MutationUpdaterFunction<
  ContractCreateMutation,
  Exact<{ data: ContractCreateInput }>,
  DefaultContext,
  ApolloCache<any>
> =
  clientId =>
  (cache, { data: mutationData }) => {
    if (mutationData) {
      // add contract to ContractsListQuery
      cache.updateQuery<ContractsListQuery, ContractsListQueryVariables>(
        { query: ContractsListDocument, variables: { clientId } },
        queryData => {
          if (queryData) {
            const { contractCreate: contract } = mutationData;
            return {
              ...queryData,
              contracts: {
                ...queryData.contracts,
                edges: [
                  { __typename: 'ContractEdge', node: contract },
                  ...queryData.contracts.edges,
                ],
              },
            };
          }
          return null;
        }
      );

      // add contract documents to DocumentsQuery
      cache.updateQuery<DocumentsQuery, DocumentsQueryVariables>(
        { query: DocumentsDocument, variables: { clientId } },
        queryData => {
          if (queryData) {
            const edges: DocumentEdge[] = mutationData.contractCreate.documents.edges
              .map(edge => edge.node!)
              .map(node => ({
                __typename: 'DocumentEdge',
                node,
              }));

            return {
              ...queryData,
              documents: {
                ...queryData.documents,
                edges: [...queryData.documents.edges, ...edges],
              },
            };
          }
          return null;
        }
      );
    }
  };
